import _defineProperty from "/var/lib/jenkins/workspace/aws-PROD-deploy-react-form/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/defineProperty";

function isDynamicTokenSubtree(subtree) {
  return !Array.isArray(subtree) && typeof subtree !== 'string';
}

export function getDynamicTokens(tokens, path) {
  return Object.keys(tokens).reduce(function (result, key) {
    var newPath = path ? "".concat(path, ".").concat(key) : key;
    var currentToken = tokens[key];

    if (Array.isArray(currentToken)) {
      currentToken.forEach(function (dynamic) {
        result[dynamic.breakpoint] = result[dynamic.breakpoint] || {};
        result[dynamic.breakpoint] = Object.assign({}, result[dynamic.breakpoint], _defineProperty({}, newPath, dynamic.value));
      });
      return result;
    }

    if (isDynamicTokenSubtree(currentToken)) {
      var subtreeResults = getDynamicTokens(currentToken, newPath);
      Object.keys(subtreeResults).forEach(function (breakpoint) {
        result[breakpoint] = Object.assign({}, result[breakpoint] || {}, subtreeResults[breakpoint]);
      });
      return result;
    }

    return result;
  }, {});
}